import { Block } from '@gitbook/slate';

import { BLOCK_OPENAPI_OPERATION, type BlockOpenAPIOperationData } from '../types';

/**
 * Create an OpenAPI Operation block referencing an OpenAPI specification.
 */
export function createBlockWithRef(data: BlockOpenAPIOperationData): Block {
    return Block.createVoid({
        type: BLOCK_OPENAPI_OPERATION,
        data,
    });
}
